import { MainContentContainer, MainSection } from '../OtherPages.styles';
// import Images from '../../Visuals/Images/large.jpg';
import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
const ClassroomTraining = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Classroom Training"
        description="Classroom Training "
      />
      <SideContainerComponent />
      <MainSection>
        <h2>Classroom Training</h2>
        <p>Coming Soon...</p>
      </MainSection>
    </MainContentContainer>
  );
};

export default ClassroomTraining;
